import React from 'react';
import AccentChairs from '../../components/accent-chairs';

const Chairs = () => {
    return (
        <div>

            <AccentChairs />
        </div>
    )
}

export default Chairs;